import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { AppSettingsService } from './app-settings.service';
import { HttpService } from './http.service';
import { hd } from './xsight-types';
import { ResourceType } from './roles/roles.models';

@Injectable({
  providedIn: 'root',
})
export class ResourcePermissionService {
  groupPermissionMap = new Map<number, Observable<hd.GroupPermissionType[]>>();
  private readonly PERMISSION_ENDPOINT = 'permission';

  constructor(private httpClient: HttpService, private appSettingsService: AppSettingsService) {}

  public getResourcePermissions(resourceType: ResourceType, id: number): Observable<ResourcePermissionResponse> {
    return this.httpClient.get<ResourcePermissionResponse>(
      this.appSettingsService.accountServiceUrl + this.PERMISSION_ENDPOINT + `/${resourceType}/${id}`
    );
  }

  public removeGroupPermissionObservable = (id: number): void => {
    if (id > -1 && this.groupPermissionMap.has(id)) {
      this.groupPermissionMap.delete(id);
    }
  };

  public getGroupPermissions$ = (id: number): Observable<hd.GroupPermissionType[]> => {
    if (!this.groupPermissionMap.has(id)) {
      const obs$ = this.getResourcePermissions(ResourceType.Group, id).pipe(
        map(r => r.permissions as hd.GroupPermissionType[]),
        shareReplay(1)
      );
      this.groupPermissionMap.set(id, obs$);
    }

    return this.groupPermissionMap.get(id);
  };

  public hasGroupPermissionAccess$ = (id: number, permission: hd.GroupPermissionType): Observable<boolean> => {
    return this.getGroupPermissions$(id).pipe(map(res => res.includes(permission)));
  };
}

export interface ResourcePermissionResponse {
  permissions: Array<string>;
}
